import { render, staticRenderFns } from "./Jurnalgroup.vue?vue&type=template&id=725d4706"
import script from "./Jurnalgroup.vue?vue&type=script&lang=js"
export * from "./Jurnalgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports